// 引入ant-design-vue框架
import {
  Button,
  ConfigProvider,
  Input,
  InputNumber,
  Select,
  FormModel,
  Spin,
  Icon,
  Table,
  Row,
  Col,
  Switch,
  message,
  Popconfirm,
  Modal,
  Radio,
  Checkbox,
  Card,
  Statistic,
  Tag,
  Descriptions,
  DatePicker,
  TimePicker,
  Divider,
  Upload,
  Tabs,
  Tooltip,
  Progress,
  Timeline,
  Drawer,
  Dropdown,
  List,
  Cascader,
} from 'ant-design-vue'
import confirm from 'ant-design-vue/es/modal/confirm'
// import 'ant-design-vue/dist/antd.css'

const Ant = {
  install: function (Vue) {
    // 注册ant-design-vue
    Vue.use(Button).use(ConfigProvider).use(Input).use(InputNumber).use(Select).use(FormModel).use(Spin).use(Icon).use(Table).use(Row).use(Col).use(Switch).use(Popconfirm).use(Modal).use(Radio).use(Checkbox).use(Card).use(Statistic).use(Tag).use(Descriptions).use(DatePicker).use(TimePicker).use(Divider).use(Upload).use(Tabs).use(Tooltip).use(Progress).use(Timeline).use(Drawer).use(Dropdown).use(List).use(Cascader)
    Vue.prototype.$message = message
    Vue.prototype.$error = Modal.error
    Vue.prototype.$confirm = confirm
    Vue.prototype.$modalDestroyAll = Modal.destroyAll
  }
}

export default Ant



// WEBPACK FOOTER //
// ./src/utils/ant.js